import { useEffect } from 'react';

import useOrgSettingsStore from '../stores/orgSettingsStore';

/**
 * useLabEnabled — single source of truth for "is the Lab module on for this org".
 *
 * Lazily fetches the per-org `enable_lab_module` flag once per session and
 * returns it. Every lab surface (menu, catalog, visit section, routes) gates on
 * this so nothing lab-related renders when the module is off.
 */
export default function useLabEnabled() {
  const enableLabModule = useOrgSettingsStore((s) => s.enableLabModule);
  const labLoaded = useOrgSettingsStore((s) => s.labLoaded);
  const fetchLabSettings = useOrgSettingsStore((s) => s.fetchLabSettings);

  useEffect(() => {
    if (!labLoaded) fetchLabSettings();
  }, [labLoaded, fetchLabSettings]);

  return enableLabModule;
}
